module.exports = __webpack_public_path__ + "media/images/business/img-feature-search-79132ec2c60b3998cc8a703b9c3660f7.png";